//#region [IMPORT]

// === THIRD-PARTY ===
import React, {useEffect, useState} from 'react';
import { useNavigate } from "react-router-dom";

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import { Close } from '@mui/icons-material';

// === COMPONENTS ===
import Styled from 'components/Styled/Styled';
import {Spacer} from 'components/Spacer';

// === API ===
import { on, removeListener } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function HeaderFileViewer() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme    = useTheme();
  const navigate = useNavigate();

  const [ file_name , setFileName ] = useState( '' );

  //#endregion
  
  //#region [EFFECT]

  useEffect( () => {
    //-----------------------------------------------------------------
    function handleFile(data) {
      //-----------------------------------------------------------------
      if( data?.name ) setFileName( data?.name );
    }

    on( 'FILE', handleFile );

    return () => {
      removeListener( 'FILE' , handleFile );
    };
  }, [] )

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onClick( event ) {
    //-----------------------------------------------------------------
    navigate( '/files', { replace: true } );
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Styled styles={[{display: 'flex'}, {alignItems:'center'}]}>
        <Styled styles={[{width:'fit-content', height: 'fit-content'}, { fontSize: '20px' }, { padding: '4px 8px 4px 8px' } ]}>
          {file_name}
        </Styled>
        <button style={{marginLeft: 'auto', cursor:'pointer', border: '0px', borderRadius: '5px', height: '40px', width: '50px', background: theme.palette.primary.main, color: theme.palette.primary.contrastText}} onClick={onClick} title='Close File'>
          <Close fontSize='large'/>
        </button>
        <Spacer />
      </Styled>
    )
  }

  //#endregion

  return display();
}
